import { ButtonHTMLAttributes } from 'react'

import { chakra } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'

export const AbsoluteContainer = chakra('div', {
    baseStyle: {
        position: 'absolute',
        top: '10px',
        left: '10px',
        zIndex: 999999,
        background: '#fff',
        padding: '8px',
        borderRadius: '2px',
        boxShadow: '0 2px 10px rgb(0 0 0 / 25%)',
        display: 'flex',
    },
})

const blink = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.2;
    }
    100% {
        opacity: 1;
    }
`
export const RecordIconWrapper = chakra('div', {
    baseStyle: {
        color: 'red',
        animation: `${blink} 2s linear 0s infinite`,
    },
})

export const Button = chakra('div', {
    baseStyle: {
        marginLeft: '8px',
        cursor: 'pointer',
    },
})

export const TextWrapper = chakra('div', {
    baseStyle: {
        margin: '0px 4px',
    },
})

export const IconWrapper = chakra<'button', ButtonHTMLAttributes<HTMLButtonElement>>('button', {
    baseStyle: (props) => {
        const { disabled } = props

        return {
            padding: '0px 4px',
            margin: '0px 4px',
            background: 'inherit',
            border: 0,
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
        }
    },
})
